import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
};

export const fetchAdminOrders = createAsyncThunk('adminOrders/fetchOrders', async (_, { rejectWithValue }) => {
  try {
    const res = await axios.get('http://localhost:5000/api/admin/orders', getAuthHeaders());
    return res.data.orders;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch orders');
  }
});

export const updateAdminOrderStatus = createAsyncThunk('adminOrders/updateStatus', async ({ id, status }, { rejectWithValue }) => {
  try {
    const res = await axios.put(`http://localhost:5000/api/admin/orders/${id}/status`, { status }, getAuthHeaders());
    return res.data.order;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to update order status');
  }
});

const adminOrdersSlice = createSlice({
  name: 'adminOrders',
  initialState: {
    orders: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminOrders.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchAdminOrders.fulfilled, (state, action) => { state.loading = false; state.orders = action.payload; })
      .addCase(fetchAdminOrders.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(updateAdminOrderStatus.fulfilled, (state, action) => {
        const idx = state.orders.findIndex(o => o._id === action.payload._id);
        if (idx !== -1) {
          state.orders[idx] = action.payload;
        }
      });
  }
});

export default adminOrdersSlice.reducer;
